/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MultiNightRate } from './MultiNightRate';
import {
    MultiNightRateFromJSON,
    MultiNightRateFromJSONTyped,
    MultiNightRateToJSON,
    MultiNightRateToJSONTyped,
} from './MultiNightRate';

/**
 * Response to the /hotel/{hotel_id}/multi_night_rates
 * @export
 * @interface MultiNightRatesResponse
 */
export interface MultiNightRatesResponse {
    /**
     * 
     * @type {Array<MultiNightRate>}
     * @memberof MultiNightRatesResponse
     */
    items?: Array<MultiNightRate>;
}

/**
 * Check if a given object implements the MultiNightRatesResponse interface.
 */
export function instanceOfMultiNightRatesResponse(value: object): value is MultiNightRatesResponse {
    return true;
}

export function MultiNightRatesResponseFromJSON(json: any): MultiNightRatesResponse {
    return MultiNightRatesResponseFromJSONTyped(json, false);
}

export function MultiNightRatesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MultiNightRatesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(MultiNightRateFromJSON)),
    };
}

export function MultiNightRatesResponseToJSON(json: any): MultiNightRatesResponse {
    return MultiNightRatesResponseToJSONTyped(json, false);
}

export function MultiNightRatesResponseToJSONTyped(value?: MultiNightRatesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(MultiNightRateToJSON)),
    };
}

